import { all, call, put, takeEvery } from 'redux-saga/effects';
import { apiPost } from '../core/dapi';
import { getAddBackupTimeUrl } from '../core/dapi/newBooking';

export class AddBackupTimesSagas {
  static ADD_BACKUP_TIMES = 'SAGA/ADD_BACKUP_TIMES';
}

function* addBackupTimes({ bookingId, backupTimes, locationId, onSuccess }) {
  yield all(
    backupTimes.map(time =>
      call(apiPost, getAddBackupTimeUrl(), {
        booking_id: bookingId,
        backup_appointment_date: time,
      })
    )
  );

  onSuccess();
}

export default function*() {
  yield takeEvery(AddBackupTimesSagas.ADD_BACKUP_TIMES, addBackupTimes);
}
